import React from "react";
import { Link } from "react-router-dom";
import Icon from "./Icon";

function MegaMenu({ menu, onNavigate }) {
  return (
    <div className="mega-menu" role="menu">
      <div className={`mega-menu-columns mega-menu-columns--${menu.columns.length}`}>
        {menu.columns.map((col) => (
          <div className="mega-menu-column" key={col.heading}>
            <span className="mega-menu-heading">{col.heading}</span>
            <ul>
              {col.items.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="mega-menu-item" onClick={onNavigate}>
                    <span className="mega-menu-item-icon">
                      <Icon name={item.icon} size={18} />
                    </span>
                    <span className="mega-menu-item-text">
                      <span className="mega-menu-item-label">{item.label}</span>
                      {item.description && (
                        <span className="mega-menu-item-desc">{item.description}</span>
                      )}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MegaMenu;
